import React, { useEffect, useContext, useState } from "react";
import { P, SecondaryButton } from "@itpi/react-components";
import { Page } from "../components/Page";
import { GetSelfAssessment, GetSelfAssessmentForm } from "../data/QuestionApi";
import AuthContext from "../context/AuthContext";
import { useParams, Link } from "react-router-dom";
import {
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  RadarChart,
  ResponsiveContainer,
} from "recharts";
import moment from "moment";
import loadingbanner from "../assets/resultbanner.svg";

export const Result: React.FC<{headerControl: any}> = ({headerControl}) => {
  const { token } = useContext(AuthContext);
  const { id } = useParams<{ id: string }>();
  const [assessment, setAssessment] = useState<any>(null);
  const [printable, setPrintable] = useState<boolean>(false);

  const [formattedResults, setFormattedResults] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const [graphData, setGraphData] = useState<any>([
    { count: 8 }, //placeholder data makes the loading state better!
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
  ]);

  useEffect(() => {
    setLoading(true);
    const resultPromise = GetSelfAssessment(token, id);

    const formPromise = GetSelfAssessmentForm(token);

    Promise.all([resultPromise, formPromise]).then((results) => {
      if (results[0].id !== undefined) {
        setAssessment(results[0]);
        console.log(results[0]);
        const data = results[0].answers
          .sort((a: any, b: any) => {
            return a.competency.id - b.competency.id;
          })
          .map((x: any) => {
            return { type: x.competency.name, score: x.score };
          });
        setGraphData(data);
      }

      let displayData = [...results[1]];

      results[1].map((area: any, aindex: number) => {
        area.competencies.map((competency: any, cindex: number) => {
          const answerIndex = results[0].answers.findIndex(
            (x: any) => x.competency.id === competency.id
          );
          displayData[aindex].competencies[cindex].answer =
            results[0].answers[answerIndex];
        });
      });

      setFormattedResults(displayData);

      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <Page>
        <img
          src={loadingbanner}
          width="90%"
          style={{
            margin: "5%",
          }}
          height="400px"
          alt="banner for loading screen"
        />
        <P style={{ textAlign: "center" }}>Loading your Results...</P>
      </Page>
    );
  }

  window.addEventListener("popstate", e => {
      headerControl(true);
  })

  if (!printable) {
      headerControl(true);
  }

  const height = 350;
  const width = 730;

  return (
    <Page>
      {assessment !== null ? (
        <>
          <h1 style={{ fontSize: 20, lineHeight: 1 }}>
            Assessment Submitted{" "}
            {moment(assessment?.dateCreated).format("DD/MM/YYYY HH:mm")}
            <Link to="">
              <SecondaryButton style={{ flexGrow: 0, marginLeft: 10}}>
                Home{" "}
              </SecondaryButton>
            </Link>

            { printable ? "" :<SecondaryButton style={{float: "right"}} onClick={()=>{setPrintable(true); headerControl(false)}}>Printable View</SecondaryButton>}
          </h1>
            
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <div style={{ width: "50%" }}>
              <ResponsiveContainer width={"100%"} height={400}>
                <RadarChart
                  outerRadius={"80%"}
                  width={width}
                  height={height}
                  data={graphData}
                >
                  <PolarGrid />
                  <PolarAngleAxis
                    dataKey="type"
                    tick={({ payload, x, y, textAnchor, stroke, radius }) => {
                      return (
                        <g className="recharts-layer recharts-polar-angle-axis-tick">
                          <text
                            radius={radius}
                            stroke={stroke}
                            x={x - (-x + width / 2) / 20}
                            y={y - (-y + height / 2) / 20}
                            className="recharts-text recharts-polar-angle-axis-tick-value"
                            textAnchor={textAnchor}
                          >
                            <tspan
                              x={x}
                              dy="0em"
                              style={{
                                fontFamily: "EffraRegular",
                                fontSize: 13,
                              }}
                            >
                              {payload.value}
                            </tspan>
                          </text>
                        </g>
                      );
                    }}
                  />
                  <PolarRadiusAxis angle={30} stroke={"#333"} domain={[0, 8]} />

                  <Radar
                    name="Competencies"
                    dataKey="score"
                    stroke="#b5121b"
                    fill="#b5121b"
                    fillOpacity={0.6}
                    animationDuration={300}
                  />
                </RadarChart>
              </ResponsiveContainer>
            </div>

            { printable ? <div style={{ width: "100%", height: "20px" }}></div> : "" }

            <div style={{ display: "flex", flexDirection: "column" }}>
              {formattedResults?.map((area: any) => {
                return (
                  <>
                    <h2 style={{ fontSize: 22 }}>{area?.name}</h2>
                    {area.competencies.map((competency: any) => {
                      return (
                        <>
                          <h3 style={{ fontSize: 20, fontWeight: "normal" }}>
                            {competency.name}
                            {competency?.answer?.score
                              ? `: ${competency?.answer?.score}`
                              : null}
                          </h3>
                          <p style={{ fontSize: 16 }}>
                            {competency?.answer?.answerText}
                          </p>
                        </>
                      );
                    })}
                  </>
                );
              })}
            </div>
          </div>
        </>
      ) : null}
    </Page>
  );
};
